import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { useDispatch } from "react-redux";

import ItemService from "../../../services/supplier_appCommonService";
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { addQualityCheckNr } from "../../../redux/feature/supplier_app/qualityCheckSlice";
import { SearchField } from "../../../Components/formElements/SearchField";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import ConfirmationLoader from "../../../Components/ConfirmationLoader";
import { formatDateTime } from "../../../common/Validations";
import CancelModal from "../../../Components/Modal/supplier_app/common/CancelModal";

const QualityCheckList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Quality Check");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const [isCardVisible, setCardVisible] = useState(true);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  useEffect(() => {
    loadQualityCheckData();
    // eslint-disable-next-line
  }, [page, perPage, searchTerm]);

  const loadQualityCheckData = async () => {
    setLoading(true);
    try {
      let obj = {
        page: page,
        per_page: perPage,
        searchTerm: searchTerm || undefined,
      };
      const res = await ItemService.getQualityCheckList(obj);
      if (res?.status === 200) {
        setData(res.data || []);
        setTotalRecords(res.total || 0);
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (err) {
      console.log("Error loading quality checks:", err);
      setData([]);
      setTotalRecords(0);
    }
    setLoading(false);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const handleSearchFuncApi = () => {
    setPage(1);
    loadQualityCheckData();
  };

  const handleView = (row) => {
    dispatch(addQualityCheckNr(row.qualityCheckNr));
    navigate(Constants.POCOLLABRATION_QUALITY_CHECK_DETAILS);
  };

  const handleEdit = (row) => {
    dispatch(addQualityCheckNr(row.qualityCheckNr));
    navigate(Constants.POCOLLABRATION_QUALITY_CHECK_UPDATE);
  };

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.qualityCheckStatus !== "Cancelled"
    );
    setSelectedRows(validRows);
  };
 // eslint-disable-next-line 
  const confirmCancel = async () => {
    if (getSelectedRows.length === 0) return;
    try {
      for (let row of getSelectedRows) {
        let obj = { qualityCheckNr: row.qualityCheckNr };
        await ItemService.cancelQualityCheck(obj);
      }
      toast.success("Quality Checks cancelled successfully");
      cancelModalHide();
      setSelectedRows([]);
      loadQualityCheckData();
    } catch (err) {
      toast.error("Error cancelling quality checks");
    }
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      Created: "badge bg-primary",
      "In Progress": "badge bg-warning text-dark",
      Passed: "badge bg-success",
      Failed: "badge bg-danger",
      Conditional: "badge bg-info",
      Cancelled: "badge bg-secondary",
    };
    return statusColors[status] || "badge bg-secondary";
  };

  const columns = [
    {
      name: "Inspection No.",
      selector: (row) => row.qualityCheckNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => handleView(row)}>
          {row.qualityCheckNr}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Date",
      cell: (row) => (
        <span>{row.createdAt ? formatDateTime(row.createdAt) : "-"}</span>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "GRN",
      selector: (row) => row.grnNr || "--",
      sortable: true,
      width: "120px",
    },
    {
      name: "PO",
      selector: (row) => row.purchasingDocumentNr || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Supplier",
      selector: (row) => row.vendorName || row.vendorCode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Inspection Qty",
      selector: (row) => row.inspectionQuantity || "--",
      sortable: true,
      center:true,
      width: "140px",
    },
    {
      name: "Accepted",
      selector: (row) => row.acceptedQuantity || "--",
      sortable: true,
      center:true,
      width: "110px",
      cell: (row) => (
        <span className="text-success fw-bold">
          {row.acceptedQuantity || "--"}
        </span>
      ),
    },
    {
      name: "Rejected",
      selector: (row) => row.rejectedQuantity || "--",
      sortable: true,
      center:true,
      width: "110px",
      cell: (row) => (
        <span className="text-danger fw-bold">
          {row.rejectedQuantity || "--"}
        </span>
      ),
    },
    {
      name: "Score",
      selector: (row) => row.qualityScore || "--",
      sortable: true,
      width: "90px",
      center:true,
    },
    {
      name: "Result",
      selector: (row) => row.overallResult || "--",
      sortable: true,
      width: "110px",
      cell: (row) => {
        const result = row.overallResult;
        if (!result) return <span>--</span>;
        const cls =
          result === "Pass"
            ? "text-success"
            : result === "Fail"
            ? "text-danger"
            : "text-warning";
        return (
          <span className={`fw-bold ${cls}`}>{result}</span>
        );
      },
    },
    {
      name: "Status",
      selector: (row) => row.qualityCheckStatus,
      cell: (row) => (
        <span className={getStatusBadge(row.qualityCheckStatus)}>
          {row.qualityCheckStatus}
        </span>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Action",
      width: "120px",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-outline-primary"
            title="View"
            onClick={() => handleView(row)}
          >
            <i className="bi bi-eye"></i>
          </button>
          {row.qualityCheckStatus !== "Cancelled" &&
            row.qualityCheckStatus !== "Passed" && (
              <button
                className="btn btn-sm btn-outline-secondary"
                title="Edit"
                onClick={() => handleEdit(row)}
              >
                <i className="bi bi-pencil"></i>
              </button>
            )}
        </div>
      ),
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <ConfirmationLoader isPageLoading={loading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Quality Check</h2>
                <p className="subText">
                  Lists of Quality Check Inspections and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>

            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QC</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Quality Check List</span>
                      <span className="subHeaderTitle">
                        View of Quality Check Inspections and Status{" "}
                      </span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={12} md={12} lg={12}>
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 5]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={totalRecords}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                          noDataComponent="No Quality Checks found"
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CancelModal
        title="Cancel Quality Check"
        type="QualityCheck"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
    </main>
  );
};

export default QualityCheckList;
